module.exports = __webpack_public_path__ + "media/images/emoticons/heart04-2f95732717a56e90b27c95bde2afa03b.gif";